import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { IResidentFeedbackState } from './resident-feedback.reducer';
import * as fromReducer from './resident-feedback.reducer';

const getResidentFeedbackState = createFeatureSelector<IResidentFeedbackState>('residentFeedback');

export const getResidentFeedbackEligibility = createSelector(
  getResidentFeedbackState,
  fromReducer.getEligibility
);

export const getResidentFeedbackPromptShown = createSelector(
  getResidentFeedbackState,
  fromReducer.getPromptShownThisSession
);

export const getSaveResidentFeedbackActionState = createSelector(
  getResidentFeedbackState,
  fromReducer.getSaveFeedbackActionState
);

/**
 * The BE covers AC 1a (registered >= 2 weeks) and AC 1b (not asked in 3 months).
 * The session guard stops a second prompt when two successful events land in one
 * run (ART-19551 spec FR-3 / ED-3).
 */
export const canShowResidentFeedbackPrompt = createSelector(
  getResidentFeedbackEligibility,
  getResidentFeedbackPromptShown,
  (eligibility, shown) => eligibility?.eligible === true && !shown
);
